// extracted by mini-css-extract-plugin
export default {"root":"reVE4c","isMobile":"g8p4fi","isReply":"LxfxqA","avatar":"JCVpUk","message":"S02zZO"};